module.exports = __webpack_public_path__ + "img/main-01-07.b0ac41fd.png";